




import Vue from "vue";
import Component from "vue-class-component";
import { LGeoJson } from "vue2-leaflet";
import { Icon, LatLng, LeafletMouseEvent, Layer, marker } from "leaflet";
import { IAton } from "@/store/targets/models";
import { targets, maps } from "@/store";
import { MutationTypes } from "@/store/mutations-types";

const atonUrl = require("../../../assets/icons/ais/ais-aton.svg")

@Component({
  components: {
    LGeoJson,
  },
})
export default class AtonsLayer extends Vue {
  //computed
  get geoJsonOptions() {
    return {
      pointToLayer: this.atonPoint,
      onEachFeature: this.onEachFeatureFunction,
    };
  }
  get onEachFeatureFunction() {
    return (feature: IAton, layer: Layer) => {
      layer.bindTooltip(feature.properties.name, {
        permanent: false,
        sticky: true,
      });
      layer.bindPopup(`Nombre: ${feature.properties.name} 
        <br> MMSI: ${feature.mmsi}`);
      layer.on("click", (response: LeafletMouseEvent) => {
        if (maps.getters.measurementActivated) {
          maps.commit(MutationTypes.ADD_MEASUREMENT_POINT, {
            tipo: "aton",
            data: response.latlng,
          });
        }
      });
    };
  }
  get atonPoint() {
    return (feature: IAton, latlng: LatLng) => {
      let atonIcon = new Icon({
        iconSize: [50, 50],
        iconUrl: atonUrl,
      });
      return marker(latlng, { icon: atonIcon });
    };
  }
  get atons() {
    return targets.getters.atonsList;
  }

  //methods
  loadFeatures() {
    targets.dispatch("getAtons");
  }

  created() {
    this.loadFeatures();
  }
}
